export default __webpack_public_path__ + "static/media/metamarko.54ccbb7a.png";